import { reactive, ref } from "vue";
// import { Employee, UserPermissions } from "@/models";
import type { UserContext } from "./context";
// import { useAuthApi } from "@/core/composables/useAuthApi";
import { useUserProfileApi } from "@/core/composables/useUserProfileApi";
// import { RoleEnum } from "@/core/enum";
import { useAppContextStore } from "./AppContextStore";
import { resumeService } from "../services/resume.service";
import { useAuthApi } from "../composables/useAuthApi";

export const data = ref(null);
export const authenticated = ref(false);

// export const context: UserContext = reactive({
//   id: "",
//   email: "",
//   role: RoleEnum.EMPLOYEE,
//   resumeId: null,
//   manager: {} as Employee,
//   managedEmployees: [],
//   permissions: {} as UserPermissions,
//   firstName: "",
//   lastName: "",
//   authenticated: false,
// });

async function ensureResume(appContext = useAppContextStore()) {
  const user = appContext.context.user;

  if (user.resumeId != null) return;
  if (!user.id) return;

  const response = await resumeService.postResume({ employeeId: user.id });
  if (response?.id) {
    // update store context with new resumeId
    appContext.setUserContext({ ...user, resumeId: response.id });
  }
}

function applyUserContext(ctx: UserContext) {
  (ctx.permissions as any) ??= {};
  (ctx.permissions as any).page ??= {};

  ctx.authenticated = true;
  authenticated.value = true;
}

export async function load() {
  const { refreshTokenIfNeeded } = useAuthApi();
  const { fetchUserProfile, userContext } = useUserProfileApi();
  const appContext = useAppContextStore();

  await refreshTokenIfNeeded();

  await fetchUserProfile();
  const ctx = userContext.value;

  applyUserContext(ctx);
  appContext.setUserContext(ctx);

  ensureResume(appContext).catch(console.error);
}

export const user = reactive({
  data,
  authenticated,
  load,
});
